import BigNumber from 'bignumber.js'

import { CardBody, Flex, Text, CardRibbon } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from 'contexts/Localization'
import { BIG_TEN, BIG_ZERO } from 'utils/bigNumber'
import { DeserializedPool } from 'state/types'
import { TokenImage, TokenPairImage } from 'components/TokenImage'
import { usePool } from 'state/pools/hooks'
import AprRow from './AprRow'
import { StyledCard } from './StyledCard'
import CardFooter from './CardFooter'
import PoolCardHeader, { PoolCardHeaderTitle } from './PoolCardHeader'
import CardActions from './CardActions'

const PoolCard: React.FC<{ pool: DeserializedPool; account: string }> = ({ pool, account }) => {
  const { sousId, stakingToken, earningToken, isFinished, userData } = pool
  const { t } = useTranslation()
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO
  const accountHasStakedBalance = stakedBalance.gt(0)

  const { pool: handPool } = usePool(21)
  const { pool: bnbPool } = usePool(38)
  const { pool: hodlPool } = usePool(14)

  const priceHand = bnbPool.tokenPrice
    ? new BigNumber(handPool.earningTokenPrice).times(new BigNumber(bnbPool.tokenPrice.toString()))
    : new BigNumber(0)
  const hodlPrice = bnbPool.tokenPrice
    ? new BigNumber(pool.earningTokenPrice)
        .times(new BigNumber(hodlPool.tokenPrice.toString()))
        .times(new BigNumber(bnbPool.tokenPrice.toString()))
    : new BigNumber(0)

  const discountRate = 1 - hodlPrice.div(priceHand).toNumber()

  const discountSave = priceHand.times(discountRate)

  const discountRatePercent = pool.discountRate !== undefined ? pool.discountRate.toString() : discountRate.toFixed(0)

  return (
    <StyledCard
      isFinished={isFinished && sousId !== 0 && sousId !== 15}
      ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={t('Finished')} />}
    >
      <PoolCardHeader isStaking={accountHasStakedBalance} isFinished={isFinished && sousId !== 0 && sousId !== 15}>
        <PoolCardHeaderTitle
          title={t('Buy HODL Hands® NFTs with $HODL')}
          subTitle={t('Exclusive discount for $HODL holders')}
        />
        <TokenPairImage primaryToken={earningToken} secondaryToken={stakingToken} width={64} height={64} />
      </PoolCardHeader>
      <CardBody>
        <AprRow
          pool={pool}
          stakedBalance={stakedBalance}
          discountRatePercent={discountRatePercent}
          discountSave={discountSave}
          busdPrice={hodlPrice.toNumber()}
        />
        <Flex mt="24px" flexDirection="column">
          {account ? (
            <CardActions pool={pool} stakedBalance={stakedBalance} discountSave={discountSave} />
          ) : (
            <>
              <ConnectWalletButton />
            </>
          )}
        </Flex>
      </CardBody>
    </StyledCard>
  )
}

export default PoolCard
